@switch(type$ | async){ @case(dialogType.LOGIN_REGISTER){
<login-register [tabIndex]="tabIndex"></login-register>
} @case(dialogType.REGISTER_AGREE){
<register-agree [callback]="registerAgree"></register-agree>
} @case(dialogType.LOGIN_2FA){
<verify-2fa
  [header]="loginService.login2faHeader"
  title="Two Step verification"
  [submitText]="loginService.login2faSubmitText"
  [sendType]="loginService.login2faSendType"
  [email]="loginService.email"
  [mobile]="loginService.mobile"
  [areaCode]="loginService.areaCode"
  [otpType]="loginService.otpType"
  [isSpecificType]="true"
  [submitFunc]="loginService.verify2fa.bind(loginService)"
  (sendTypeChange)="loginService.updateLogin2faSendType($event)"
></verify-2fa>
} @case(dialogType.RESET_PASSWORD){
<reset-password></reset-password>
} @case(dialogType.RESET_PASSWORD_EMAIL){
<reset-password-email></reset-password-email>
}@case(dialogType.THIRD_PARTY){
<third-party></third-party>
} @case (dialogType.KYC) {
<kyc-dialog
  title="Sign up"
  [requireTerms]="loginService.needKyc"
  [requireEmail]="!loginService.email"
  [prefillEmail]="loginService.email"
  [loading]="kycLoading"
  (submitted)="onKycSubmit($event)"
  (closed)="onKycClose()"
></kyc-dialog>
} }
